// auth/auth.interceptor.ts
import { HttpInterceptorFn, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { openIdConfig } from '../auth-config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const oidc = inject(OidcSecurityService);

  if (req.headers.has('Authorization')) {
    return next(req);
  }

  const isSecure = openIdConfig.secureRoutes?.some(
    route => route && req.url.startsWith(route)
  );

  if (!isSecure) {
    return next(req);
  }

  return oidc.getAccessToken().pipe(
    switchMap(token => {
      if (!token) {
        // NÃO chame authorize() aqui — apenas falhe silenciosamente
        // O guard já cuida do redirecionamento ao IdP
        return throwError(() => new Error('Token not available'));
      }

      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
      return next(authReq);
    })
  );
};